export const [FETCH_STICKIES_SUCCESS, UPDATE_NEW_STICKY_BODY, CREATE_STICKY_SUCCESS, REPLY_STICKY_SUCCESS, UPDATE_REPLY_STICKY_BODY] =
    ['FETCH_STICKIES_SUCCESS', 'UPDATE_NEW_STICKY_BODY', 'CREATE_STICKY_SUCCESS', 'REPLY_STICKY_SUCCESS', 'UPDATE_REPLY_STICKY_BODY']
